import { useCallback, useState } from "react";

import { CaseDocumentAdmin } from "pwapi";

import { useAppDispatch } from "app/hooks";
import { uploadDocument } from "app/reducers/admin/actions/caseActions";

const sidebarDocumentUploadForm = ({
  onClose,
  case_id,
}: {
  onClose: Function;
  case_id: number;
}) => {
  const dispatch = useAppDispatch();

  const [documentsValues, setDocumentsValues] = useState<{
    document?: File;
    category: string;
  }>({ category: "" });

  const handleOnSubmit = useCallback(() => {
    if (documentsValues.document) {
      const submitForm = new FormData();
      submitForm.append("file_uploaded", documentsValues.document);
      submitForm.append("case_id", `${case_id}`);
      documentsValues.category &&
        submitForm.append("category", documentsValues.category);
      submitForm.append("name", documentsValues.document?.name || "");

      dispatch(uploadDocument({ requestBody: submitForm }));
      onClose();
    }
  }, [documentsValues]);

  return (
    <div className="SpecimenForm">
      <label className="SpecimenFormInput">
        <span>Upload Document</span>
        <input
          type="file"
          accept="application/pdf"
          data-testid="uploadDocumentFile"
          value={documentsValues.document ? undefined : ""}
          onChange={(newFile: any) => {
            setDocumentsValues({
              ...documentsValues,
              document: newFile.target.files[0],
            });
          }}
        />
      </label>
      <label className="SpecimenFormInput">
        <span>Category</span>
        <select
          value={documentsValues.category}
          onChange={(e) => {
            setDocumentsValues({
              ...documentsValues,
              category: e.currentTarget.value,
            });
          }}
        >
          <option value="">Select...</option>
          {Object.values(CaseDocumentAdmin.category).map((type) => {
            return (
              <option value={type} key={type}>
                {type.replace("-", " ")}
              </option>
            );
          })}
        </select>
      </label>

      <button
        onClick={() => {
          onClose();
        }}
        className="Button Button--purple SpecimenForm__close"
      >
        Cancel
      </button>

      <button
        onClick={() => {
          handleOnSubmit();
        }}
        className="Button Button--purple"
      >
        Upload Document
      </button>
    </div>
  );
};

export default sidebarDocumentUploadForm;
